module.exports = __webpack_public_path__ + "img/anpassen.79093cd7.svg";